export const toFixed = function (num, s) {
    var times = Math.pow(10, s)
    var des = num * times + 0.5
    des = parseInt(des, 10) / times
    return des + ''
}

// export const msgurl="http://14533r119c.imwork.net/"
// export const msgurl="https://api.accountsir.com/accmanager/"
// export const msgurl="//192.168.1.254:81/"

// 时间戳转时间
export function getLocalTime(datetime,haveSeconds) {

    Date.prototype.toLocaleString = function() {
      if(haveSeconds&&haveSeconds=='haveSeconds'){
        return this.getFullYear() + "/" + (this.getMonth() + 1) + "/" + this.getDate() + "/ " + this.getHours() + ":" + this.getMinutes() + ":" + this.getSeconds();
      }else{
        return this.getFullYear() + "/" + (this.getMonth() + 1) + "/" + this.getDate();
      }
		};
    var unixTimestamp = new Date(datetime) ;
    var commonTime = unixTimestamp.toLocaleString();
    return commonTime;
}

// 防抖函数
export function debounce(fn,time) {
    var timer = null;
    var time = time || 500;
    return function() {
        var args = arguments;

        clearTimeout(timer);
        timer = setTimeout(()=>{
            fn.apply(this,args);
        },time)
    }
}

// 节流函数
export function throttle (fn,time) {  // time 为间隔时间
    var lastTime = null;
    var timmer_s =null;
    var time_s = time || 500;
    return function() {
        var arg_s = arguments;
        var nowTime = new Date;
        if(lastTime && nowTime - lastTime < time_s) {
            timmer_s = setTimeout(()=>{
                lastTime = nowTime;
                 fn.apply(this, args);
            },time_s)
        }else {
            lastTime = nowTime;
            fn.apply(this,arg_s);
        }
    }
}

/* 将String转为double类型 */
export function getFloatStr(num) {
	if(!num) return '';

    num = num.toString();

	if(/^\-/.test(num)) // 获取第一个负号"-"后面的数字
		num = num.split('-')[1];

	num = num.replace(/[^0-9|\.]/g, ''); // 清除字符串中的非数字非.字符

	if(/^0+/) // 清除字符串开头的0
		num = num.replace(/^0+/, '');
	if(/^\./.test(num)) // 字符以.开头时，在开关添加0
		num = '0' + num;

	// num += '00'; // 在字符串末尾补零
	// num = num.match(/\d+\.\d{0,4}/)[0];

    let newNum = num.split('.');

    if (newNum.length > 1) {
        num = newNum[0] + '.' + newNum[1];
    } else {
        num = newNum[0]
    }

    if (newNum[0].toString().length > 20) {
        return num;
    } else {
        num = (toFixed(num, 2)).toString();
        num = parseFloat(num).toFixed(2);
        // if(!/\./.test(num.toString())) // 为整数字符串在末尾添加.00
        //     num += '.00';
        return num;
    }
}

// 日期格式化
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = "yyyy-MM-dd";
function padding(s, len) {
    var len = len - (s + "").length;
    for (var i = 0; i < len; i++) { s = "0" + s; }
    return s;
};

export default {
    formatDate: {
        format (date, pattern) {
            if(date) {
                date = new Date(date);
                pattern = pattern || DEFAULT_PATTERN;
                return pattern.replace(SIGN_REGEXP, function ($0) {
                    switch ($0.charAt(0)) {
                    case "y": return padding(date.getFullYear(), $0.length);
                    case "M": return padding(date.getMonth() + 1, $0.length);
                    case "d": return padding(date.getDate(), $0.length);
                    case "w": return date.getDay() + 1;
                    case "h": return padding(date.getHours(), $0.length);
                    case "m": return padding(date.getMinutes(), $0.length);
                    case "s": return padding(date.getSeconds(), $0.length);
                    }
                });
            }
        },
        parse (dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                    case "y": _date.setFullYear(_int); break;
                    case "M": _date.setMonth(_int - 1); break;
                    case "d": _date.setDate(_int); break;
                    case "h": _date.setHours(_int); break;
                    case "m": _date.setMinutes(_int); break;
                    case "s": _date.setSeconds(_int); break;
                    }
                }
                return _date;
            }
            return null;
        }
    },
    getCell (event) {
        let cell = event.target;

        while (cell && cell.tagName.toUpperCase() !== "HTML") {
            if (cell.tagName.toUpperCase() === "TD") {
                return cell;
            }
            cell = cell.parentNode;
        }

        return null;
    }
}

export const numberOnly = {
    // 只能输入数字和小数点
    numberFloat: {
        bind (e, binding, vnode) {
            try {
                let input = e.querySelector('input')

                input.addEventListener('keydown', (e) => {
                    let k = e.keyCode;
                    if (!e.ctrlKey) {
                        if (!((k <= 57 && k >= 48) || (k <= 105 && k >= 96) || k == 8 || ( k == 110 || k == 190 || k == 9))) {
                            e.preventDefault();
                        }
                    }
                })
            } catch(e) {
            }
        }
    },
    // 只能输入负号、数字和小数点
    numberCheck: {
        bind (e, binding, vnode) {
            try {
                let input = e.querySelector('input') || e

                input.addEventListener('keydown', (e) => {
                    let k = e.keyCode;
                    if (!e.ctrlKey) {
                        if (!(
                            ( k <= 57 && k >= 46 ) ||
                            ( k <= 105 && k >= 96 ) ||
                            ( k <= 40 && k >= 37 ) ||
                            ( k == 8 || k == 9 || k == 109 || k == 110 || k == 190)
                        )) {
                            e.preventDefault();
                        }
                    }
                })
            } catch(e) {
            }
        }
    },
    // 只能输入正整数
    numberOnly: {
        update (e, { value }) {
            try {
                let input = e.querySelector('input')

                input.addEventListener('keydown', (e) => {
                    let k = e.keyCode;
                    if (!e.ctrlKey) {
                        if (!((k <= 57 && k >= 48) || (k <= 105 && k >= 96) || ( k >= 37 && k <= 40 ) || k == 8 || k ==9)) {
                            e.preventDefault();
                        }
                    }
                })
            } catch (e) {

            }
        }
    }
}

export function getFirstAndLastDayOfMonth(timestamp) {
  // 创建一个Date对象
  const date = new Date(timestamp);

  // 获取年份和月份
  const year = date.getFullYear();
  const month = date.getMonth(); // 注意：getMonth() 返回的是 0-11

  // 获取本月第一天
  const firstDayOfMonth = new Date(year, month, 1);

  // 获取本月最后一天，可以通过设置下个月的第0天来实现
  const lastDayOfMonth = new Date(year, month + 1, 0);

  // 格式化日期为 YYYY-MM-DD
  function formatDate(d) {
      return `${d.getFullYear()}-${('0' + (d.getMonth() + 1)).slice(-2)}-${('0' + d.getDate()).slice(-2)}`;
  }

  // 返回格式化后的日期字符串
  return {
      firstDay: formatDate(firstDayOfMonth),
      lastDay: formatDate(lastDayOfMonth)
  };
}



// WEBPACK FOOTER //
// ./src/assets/utils/index.js